export const tableTexts = {
  filter: {
    placeholder: {
      notes: 'Placeholder text in filter field for table columns',
      message: 'Filter',
    },
    range: {
      from: {
        notes: 'Range filter from field label',
        message: 'From',
      },
      to: {
        notes: 'Range filter to field label',
        message: 'To',
      },
    },
    number: {
      disabled: {
        notes: 'Number filter in table has no values to filter on',
        message: 'No values to filter on',
      },
    },
  },
  actions: {
    clearFilters: {
      notes: 'Label for action to clear all filters in table',
      message: 'Clear filters',
    },
    aggregations: {
      notes: 'Label for action to open menu with actions related aggregations',
      message: 'Aggregations',
    },
    showOnlyAggregations: {
      notes: 'Label for action to show only aggregations in the table',
      message: 'Aggregations only',
    },
  },
  emptyWithFilters: {
    notes: 'Message to show when table has no data after applying filters',
    message: 'No data to show, please modify your filter criteria.',
  },
  empty: {
    noContent: {
      notes: 'Text in empty table when no content exists',
      message: 'No content to show, please modify your selection.',
    },
  },
  aggregations: {
    avg: {
      notes: 'Label for average aggregation type',
      message: 'Average',
      short: {
        notes: 'Short label for average aggregation type',
        message: 'AVG',
      },
    },
    min: {
      notes: 'Label for min aggregation type',
      message: 'Min',
      short: {
        notes: 'Short label for min aggregation type',
        message: 'MIN',
      },
    },
    max: {
      notes: 'Label for max aggregation type',
      message: 'Max',
      short: {
        notes: 'Short label for max aggregation type',
        message: 'MAX',
      },
    },
    sum: {
      notes: 'Label for sum aggregation type',
      message: 'Sum',
      short: {
        notes: 'Short label for sum aggregation type',
        message: 'SUM',
      },
    },
  },
  columnSelectionButton: {
    notes: 'Title for the select columns button',
    message: 'Columns',
  },
  displayedRows: {
    notes: 'Text in table footer explaining which rows that are displayed',
    message: '{{from}}-{{to}} of {{count}}',
  },
  boolean: {
    yes: {
      notes: 'Boolean true value displayed in table cells and filters',
      message: 'Yes',
    },
    no: {
      notes: 'Boolean false value displayed in table cells and filters',
      message: 'No',
    },
  },
  groupBy: {
    selector: {
      notes: 'Label for the group by selector',
      message: 'Group by',
    },
  },
};

export default tableTexts;
